// extracted by mini-css-extract-plugin
export default {"container":"SettingsImageEditor-module__container--BQjr4","input":"SettingsImageEditor-module__input--Cuhcf"};